import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—April 2006" />
	<Old2005BlogPage>
		<h2>April 2006</h2>






		<h3 className="blogdate">
		Sunday, April 30, 2006
		</h3>






		<h4 className="blogitemtitle">
		Went to India, took along everyone on my floor
		</h4>





			<div className="blogitembody">
			I made my very first <em>dahl</em> dish tonight!<br /><br />I remembered one dahl dish from Kuala Lumpur had potatoes and carrots in it, so I added these to mine... it was quite good! I found a box of spices that included turmeric, garam masala, cumin, and crushed chilis, all of which I used. I added the garam masala, cumin, and crushed chilis last, after sweating them with onions and garlic in oil.  I also found some lime leaves, which I added even though they probably are not usually included in dahl dishes.<br /><br />My concoction stunk the entire floor in my building! My neighbor caught a sniff and knocked on my door to offer me some <em>homemade yoghurt</em>, unbelievable - I am going to learn how she made it! She says it is quite simple. She also offered me some cucumber, so I gave her some dahl and rice in trade.<br /><br />So, tonight's basic, inexpensive dinner was: dahl, rice, cucumber and yoghurt! I am full. I can't recall the last time that I was this full. I have lots of dahl remaining for another filling!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 12:34 PM &nbsp;

			</div>











		<h4 className="blogitemtitle">
		Merle's Deli: Embarrassing Times
		</h4>





			<div className="blogitembody">
			At this very moment there are three or four ex-employees of <em>Merle's Deli</em> protesting outside their former workplace. They are holding signs, demonstrating that they have not yet been paid for their work at <em>Merle's</em>. One sign says "don't eat here until we get paid!" <em>Merle's</em> is open today for brunch. I imagine that Jen is waitressing while Erick and Brad are in the kitchen. I was unable to see how many patrons were in the establishment.<br /><br />I sympathize with these people who have not been paid. I received a cheque from Brad, the manager and acting-owner, that I could not cash. After three visits to the bank (the branch that backs the cheque) I was finally able to cash it! I know of at least two other employees that are yet to be paid, and they were not protesting when I walked by.<br /><br />Today I wished I had a digital camera so I could better capture this embarrassing moment. I think I'll return to <em>Merle's</em> and inform the protestors to persist for cash if Brad offers them cheques!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:45 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Friday, April 28, 2006
		</h3>






		<h4 className="blogitemtitle">
		Irritable chainsaw yielding croc after monsoon
		</h4>





			<div className="blogitembody">
			Only in Australia would this occur!  Have a giggle!<br /><br /><a href="http://www.abc.net.au/news/newsitems/200604/s1625944.htm">ABC News story</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:17 PM &nbsp;

			</div>











		<h4 className="blogitemtitle">
		Chocolate and honey make fudge
		</h4>





			<div className="blogitembody">
			I have mentioned before that I don't care to cook with microwave ovens, however I've recently discovered another very efficient use for them.<br /><br />Cut some pure, unsweetened chocolate into shavings/pieces and put in a mug.  Add some pure honey.  Put this in the microwave for 5 seconds, then stir for 10 seconds.  Repeat two to four times and you will find that chocolate melts, while the honey turns it into a bittersweet fudge!  Spoon into your mouth, slowly, while relaxing on a couch and watching Indiana Jones.<br /><br />It's best to keep heating sessions, in the microwave, at or under 5 seconds.  This is because chocolate is very sensitive to heat, and will taste best (and have the best consistency) if kept at a moderate temperature.  40 to 45 degrees Celcius is as hot as chocolate should ever be.<br /><br />I wonder if using the microwave oven to melt chocolate is an energy-wise choice?  You are operating at 500 Watts for about 20 seconds.  It takes 5 minutes to melt chocolate in a double-boiler on the stove, not including the time and energy to heat the water in the boiler.  It takes almost an hour to melt chocolate in a warm oven.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:51 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Thursday, April 27, 2006
		</h3>






		<h4 className="blogitemtitle">
		New LP release!  Seventeen Oh-Two Oh-Six
		</h4>





			<div className="blogitembody">
			Today I came home and found boxes and boxes to be opened - it was very exciting!!! After what felt like an eternity (but was only a couple months), I now have copies of my new CD, <Link to="/music/01/">Seventeen Oh-Two Oh-Six</Link>! It's <em>tits</em>!<br /><br />

			<StaticImage
			src="../../images/catalog artwork/JRIVEST01 Seventeen Oh-Two Oh-Six front.jpg"
			alt="Jesse Rivest - Seventeen Oh-Two Oh-Six - cover art"
			placeholder="blurred"
			layout="constrained"
			className="main--centered"
			imgClassName="img--bordered-small"
			width={500}
			/>

			<br /><br />I took several opportunities tonight to review my accomplishment, and I know I will be very happy and proud to put this CD into people's hands. It embodies many things that I value, including: raw and natural audio production, independent music and small business, the beauty of human imperfection, love and freedom, creativity, simplicity, and experience. That aside, the recording on this CD is an accurate representation of the quality, sound and energy of my performance, be it around a campfire or on a star-lit beach, in a kitchen or living room, or on a stage. And the printed artwork on this CD looks nearly identical to what I created on paper, from paper grain to pencil color and texture.  With each word printed or handwritten, it looks homemade!<br /><br />If you'd like to have a copy in your hands, and you can't see me in person, then please <Link to="/contact/">contact me</Link>!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:03 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Tuesday, April 25, 2006
		</h3>






		<h4 className="blogitemtitle">
		Mankind continues to love fire (twirling)
		</h4>





			<div className="blogitembody">
			Many people have heard of fire-twirling. Before living in Australia, I had not heard of it. My friend Marc, in Calgary, would go to rave parties and photograph people twirling glow-sticks. I never made the connection that people might twirl fire - fire came before glow-sticks, so I am assuming fire-twirling has been around for some time! Fire-twirling is attractive to me, not only because I love fire, but because I love to watch people dance. To me, a great fire-twirler is one that dances with great rhythm and style while twirling.<br /><br />When I stayed in Broome, I had the wonderful pleasure of becoming acquainted with Aaron and Fionna of <a href="http://www.firetwirl.com.au/">http://www.firetwirl.com.au/</a>. Aaron and Fionna make and sell fire-twirling accessories; I once tried to twirl some unlit poi - good thing they were unlit. Many nights we'd go down to the beach: Greg would play didg in the key of D, I'd throw riffs and grooves with my guitar, and one or two people would play djembe while Aaron, Fi, Jess - and anybody else who came and was mesmerized by fire - would twirl. I remember being particularly excited by a staff that Aaron made: it had poi chained to its ends, thus it could be lit in four spots. It was unreal!<br /><br />I missed Aaron, Fi, and Jess this summer (Australian) in Margaret River. It would have been great to see them again. Looks like Jess burned herself, here's a picture that I borrowed from <a href="http://www.firetwirl.com.au">firetwirl.com.au</a> (<em>you should check out this site, the images are super cool</em>). I think she was dabbling in some body-burning and fire-breathing. She's fantastic with lit "snakes"!<br /><br />
			<StaticImage
			src="../../images/photos/old2005BlogPics/20060424/normal_jessburns.jpg"
			alt="Broome's Staircase to the Moon"
			placeholder="blurred"
			layout="constrained"
			className=""
			imgClassName="img--bordered-small"
			width={400}
			/>
			<br /><br />
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:14 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Sunday, April 23, 2006
		</h3>






		<h4 className="blogitemtitle">
		Earth Days:  fresh water thoughts
		</h4>





			<div className="blogitembody">
			After a short stint of travelling through Australia and Southeast Asia, I've gained appreciation of earth's possibly most precious resource: <em>fresh water</em>. Prior to my travels, I would have 15 to 20 minute showers, daily, and run water out of the kitchen faucets excessively.<br /><br />I started showering during the evenings, instead of early mornings when I am not quite awake. In the early mornings, I found I would sit in the shower excessively long, soaking up heat energy and water while I was half-sleeping. It took a while to become accustomed to evening showers, but I found that if I went to bed fresh and clean, I woke up fresh and clean. I drastically reduced my water usage, in the shower, by getting soaked and then stopping the water while I washed myself. I would then run the water again for a rinse!<br /><br />Sometimes that hot water felt so good on my aching muscles, though, you know? Well, here's some alternatives that I thought of: get a massage - or do some stretches, swim in the ocean, relax with a blanket, do some yoga, whatever you prefer. I can choose to conserve water and heat energy.<br /><br />And when it's very hot and humid, such as it is in tropical places, I found myself having a couple quick rinses during the day. But they were one or two minutes duration, and I ran cold water (which is warmed by the sun) only. I only did this when the ocean wasn't nearby!<br /><br />Before travelling, I used to run water out of the kitchen faucet until it was the perfect temperature for drinking (I like 22 to 30 degree Celcius). And I would dump any excess water from my glass. I look back and feel like this behaviour was crazy! Now I can fill a jug of water and let it sit at room temperature. If I wanted cold water I could put it in the refrigerator, and I can heat water to make it hot. I don't care for microwaves ovens, but my gut feeling is that one minute at 500 Watts is one of the most efficient ways to boil a cup of water in the kitchen.<br /><br />I won't forget Great Keppel Island, or any of the roadhouses on the Nullarbor or the west coast of Australia - they captured rainwater and offered it as drinking water. I believe there were purification filters in their systems, but even if not, I felt great about drinking rainwater. Now I drink chlorinated, chemically treated water from the city of Calgary, and my gut feeling says rainwater is better. It certainly tastes better!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 8:14 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Wednesday, April 19, 2006
		</h3>






		<h4 className="blogitemtitle">
		Add My Feed to Web Clips in GMail!
		</h4>





			<div className="blogitembody">
			I'm tickled that you can do this!  You can add one of my feeds below to your <em>Web Clips</em> bar in <em>GMail</em>!<br /><br />Simply go to <em>Settings</em>, <em>Web Clips</em>, and put one of my feed URLs into the <em>Search</em> field, then search for it, and you should be able to add it.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:56 PM &nbsp;

			</div>











		<h4 className="blogitemtitle">
		Caffé di Caffé Mauro:  My Favorite in Calgary!
		</h4>





			<div className="blogitembody">
			<em>Caffe Mauro</em> is a small cafe at <em>805A, 1 Street South West, Calgary, Alberta, Canada</em>.  This is my favorite cafe in Calgary, I've been a regular patron for about three years.  When I was travelling Australia, I missed this cafe, and its owner, as much as I missed my family (maybe more, ha ha)!  I have not tried the food or espresso at every cafe in Calgary, but I have to rave about my favorite place.<br /><br />For the first six months of my patronage to <em>Caffe Mauro</em> (a.k.a. <em>Cafe Mauro</em>), I ate the <em>veal parmigiana</em> sandwhich exclusively.  It is so fucking good that I couldn't stop ordering it!  Then I went through a phase of Italian cold-cuts, especially prosciutto parma and thin, thin pancetta, with provolone or fruilano cheese.  Sal makes his own olive tapanata and vegetable spread, roasts his own peppers and eggplant, sautees his own mushrooms, and bakes his own focaccia!  And he chooses the greatest, locally baked baguettes, should you prefer them over focaccia!<br /><br />One day I discovered that <em>Sal</em> had been roasting his own beef, nice and pink still on the inside, and serving this on sandwhiches.  This became a phase for me that lasted almost a year!  And his soups - all homemade!  I think every soup is a veggie soup, except the chicken/tort.  My fav will always be <em>Ironwoman soup</em>, with lentils and spinach.  This man can cook, you gotta try his food.<br /><br />One day I started eating breakfast at <em>Cafe Mauro</em>.  Sal puts together a fantastic plate of eggs, potatoes, sausage or bacon, with melon and garnish, and that fantastic local bread!  You gotta try it!  He makes muffins and cookies, too.  And after any meal, Sal's espresso is killer.  He knows his machine, he knows his coffee grounds, he knows what he's doing.  Trust him.  I've never met an espresso I preferred over Sal's, that includes when I was in Melbourne (that means something, I think).<br /><br />Today, Sal has some new sandwhiches, including a <em>chicken parmigiana</em> and a <em>chicken pimento</em>.  I haven't even tried them yet because I'm not financially well-off, and I've reduced my visits.  This hurts - honestly.  <em>Cafe Mauro</em> was always my haven, my oasis in a desert of oil, money, concrete and rushing people.  I would spend as much downtown-Calgary time at <em>Cafe Mauro</em> as I could.<br /><br />Stop supporting corporate shops like <em>Subway</em> or <em>Tim Hortons</em>, fast food places like <em>McDonald's</em> or <em>Wendy's</em>, and get yourself into a one-time local business like <em>Cafe Mauro</em>.  This man puts every ounce of his energy into his business, trust me - I know, and I give him my money anytime it is feasible.  It's a rewarding experience!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:46 AM &nbsp;

			</div>











		<h4 className="blogitemtitle">
		Merle's Deli:  Tough Times
		</h4>





			<div className="blogitembody">
			<em>Merle's Deli</em> specializes in <em>Montreal Smoked Meat</em>, and is located at <em>1241 Kensington Road North West, Calgary, Alberta, Canada</em>. For a couple reasons, I believe <em>Merle's</em> business is not doing well.<br /><br />I walked by this morning and saw that the place was shut. A sign was posted on the door saying that it closed early (Monday) and would resume normal hours on Tuesday (today). It was shut today, regardless of the note. There was a Monday, a few weeks back, where it was also shut, that time with no note on the door. These incidents bring me to wonder if <em>Merle's</em> is having some operating problems?<br /><br />I know the head chef Erick. Actually, aside from Brad (the owner), Erick is the only chef, and he works long hours every day that <em>Merle's</em> is open. There is always a <em>Help Wanted</em> sign on the door, and I believe <em>Merle's</em> is having some staffing issues.<br /><br />I know Judith, an ex-<em>Merle's</em> employee, is wondering if she will be paid for her past time at <em>Merle's</em>.<br /><br />I went to the bank yesterday, and today, to cash a cheque written by Brad, as <em>Merle's</em> owes me a small amount of money. I went to the bank that holds the chequing account that this cheque was written on, and both times I was told that this cheque cannot be cashed. I was unable to determine if there were insufficient funds in the account, or if transactions were frozen on the account, etc.<br /><br />Regardless of my frustration at being unable to claim my money from <em>Merle's</em>, I will say that the food is good at <em>Merle's</em> and the atmosphere is good. This is an independent business that I feel should be checked out! Next time you are in <em>Kensington</em>, hungry for a nibble, please support one of the local businesses. Skip the chains and franchises (like <em>Subway</em> down the street), and if you are near <em>Merle's</em>, and if it is actually open for business, then give them a try!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:25 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Friday, April 07, 2006
		</h3>






		<h4 className="blogitemtitle">
		I Know I'm Not Alone
		</h4>





			<div className="blogitembody">
			I truly enjoy Michael Franti's music.  <em>Everyone Deserves Music</em>!  It's true!  It's <em>Never Too Late</em> to check out one of his shows, or his recordings.  If I get a chance to see him again, I will - <em>Yes I Will</em>.<br /><br />I also truly enjoyed his bold and, in my opinion, unpretentious video, <em>I Know I'm Not Alone</em>.  I am biased, I fell in love with his music when I was <em>Feelin' Free</em> in Australia, it was the soundtrack to my time in Australia, and to my friendship with Cormac from Tullamore.  I now listen to Michael Franti's music anytime I need some help to <em>Stay Human</em>.  His message is simple and beautiful!<br /><br />I saw Michael Franti screen <em>I Know I'm Not Alone</em> at the Uptown Theatre in Calgary, Alberta, Canada, on March 30, 2005.  The show was sold out.  First we watched the film, after which Michael sat on stage and answered questions.  I was impressed with his honest, optimistic, yet realistic answers to all questions asked.  To end the evening, Michael performed some of his songs, reggae-style, with his folk guitar and a stomp box, and got over half the theatre up and dancing!  It's that kind of music, folks - feel good music for living and loving!<br /><br /><a href="http://www.iknowimnotalone.com/">http://www.iknowimnotalone.com/</a><br /><a href="http://www.spearheadvibrations.com/">http://www.spearheadvibrations.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 11:54 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Monday, April 03, 2006
		</h3>






		<h4 className="blogitemtitle">
		Bernard Carleton Is Silly
		</h4>





			<div className="blogitembody">
			Who is <em>Bernard Carleton</em>? He recently has boldly expressed his opinion that Canadians are scum. You can <a href="http://www.koreaherald.co.kr/SITE/data/html_dir/2006/03/29/200603290008.asp">read about his opinion in the Korea Herald</a>. According to this article, he is the organizer of a group called <em>World Class</em>, whose aim is to unite various nationalities (in Seoul) and to discuss prejudice issues.<br /><br />Bernard has definitely exhibited "world class" by stating (I quote the news article), <em>"[...]CANADIANS ARE SCUM! They are self-loving, welfare supporting, over taxing, work ethic hating scum!!! They are not welcome in our group."</em> Apparently discrimination is not an issue that <em>World Class</em> is concerned with, since they have advertised that Canadians are not welcome to join the group.<br /><br />I wonder if Bernard feels silly?  The founding philosophy of <em>World Class</em>, as I read it, seems a bit contradictory to me.  According to the article, Bernard's email address is: <a href="mailto:cbicsmd@yahoo.com">cbicsmd@yahoo.com</a>. Perhaps you'd like to send him your opinion?
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:41 AM &nbsp;

			</div>







		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
